import { render, staticRenderFns } from "./changeface.vue?vue&type=template&id=27279da6&"
import script from "./changeface.vue?vue&type=script&lang=js&"
export * from "./changeface.vue?vue&type=script&lang=js&"
import style0 from "./changeface.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports